import getProductEnv from "utils/getProductEnv";
/**
 * App Configuration based on env && __DEV__
 */
const versionNumber = 1;
const projectName = "otpless";

const config: any = {
  STAGE: {
    mock: "https://demo6198732.mockable.io/",
    client: "https://api-dashboard.otpless.com/api/v1/client/",
    website: "https://dashboard.otpless.tech/v1/website/",
    base: "https://dashboard.otpless.tech/v1/",
    versionNumber: versionNumber,
    projectName: projectName,
  },
  QA: {
    mock: "https://demo6198732.mockable.io/",
    client: "https://api-dashboard.otpless.com/api/v1/client/",
    website: "https://dashboard.otpless.tech/v1/website/",
    base: "https://dashboard.otpless.tech/v1/",
    versionNumber: versionNumber,
    projectName: projectName,
  },
  DEV: {
    mock: "https://demo6198732.mockable.io/",
    client: "https://api-dashboard.otpless.com/api/v1/client/",
    website: "https://dashboard.otpless.tech/v1/website/",
    base: "https://dashboard.otpless.tech/v1/",
    versionNumber: versionNumber,
    projectName: projectName,
  },
  PROD: {
    mock: "https://demo6198732.mockable.io/",
    client: "https://api-dashboard.otpless.com/api/v1/client/",
    website: "https://dashboard.otpless.app/v1/website/",
    base: "https://dashboard.otpless.app/v1/",
    versionNumber: versionNumber,
    projectName: projectName,
  },
};
let configs: any = config[getProductEnv()];

//Config
export default configs;
